import Logger from 'utils/logger';

export type UpgradeOutcome = 'success' | 'cancelled';
type Opener = () => Promise<UpgradeOutcome>;

let opener: Opener | null = null;
let inFlight: Promise<UpgradeOutcome> | null = null;

/**
 * Called once by `<PaymentMethodUpgradeProvider>` on mount to wire the
 * interceptor → modal connection. Pass `null` on unmount to clear.
 */
export function registerOpener(fn: Opener | null): void {
  opener = fn;
}

/**
 * Invoked by the axios interceptor on a 409 `payment_method_upgrade_required`.
 * Concurrent callers (multiple writes racing the wall) all receive the same
 * in-flight Promise so only ONE modal opens. Each caller then retries its own
 * original request after the broker resolves.
 */
export function requestUpgrade(): Promise<UpgradeOutcome> {
  if (inFlight) return inFlight;
  if (!opener) {
    Logger.error(
      '[Billing][409] requestUpgrade called but no opener registered ' +
        '(PaymentMethodUpgradeProvider missing from tree). Defensive cancel.',
    );
    return Promise.resolve<UpgradeOutcome>('cancelled');
  }
  inFlight = opener().finally(() => {
    inFlight = null;
  });
  return inFlight;
}

/** Test-only escape hatch to reset module state between tests. */
export function __resetBrokerForTests(): void {
  opener = null;
  inFlight = null;
}
